/**
 * #109 · Clientes del back-office.
 *
 * La carpeta es `hq-clients` y las pantallas viven en `routes/hq/`: el
 * descubrimiento de `AppRoutes` toma UN `moduleRoutes` por carpeta, y los tres
 * módulos del panel comparten formularios, diálogos y claves de cache. Tres
 * carpetas de una línea cada una es más barato que tocar el archivo de rutas,
 * que es justamente lo que el mecanismo existe para evitar.
 *
 * `minimumRole: 'admin'` evita montar pantallas que sólo pueden terminar en
 * 404. El control real es la API, que le responde 404 a quien no sea del
 * tenant `xyvona`, y `backoffice_guard()` del lado de Postgres.
 */
import { ClientsPage } from '../hq/ClientsPage';
import type { ModuleRoutes } from '../module';

export const moduleRoutes: ModuleRoutes = {
  moduleId: 'clients',
  minimumRole: 'admin',
  routes: [{ path: '', element: <ClientsPage /> }],
};
